<template>
  <div class="px-4 py-3 space-y-6 max-w-6xl">
    <!-- Changement de mot de passe -->
    <div class="flex items-center justify-between">
      <label class="w-1/3 text-gray-600 font-medium text-sm">Changement de mot de passe</label>
      <div class="w-2/3 flex flex-col gap-2">
        <input
          type="password"
          v-model="currentPassword"
          placeholder="Mot de passe actuel"
          class="border border-gray-200 rounded-lg px-3 py-2 text-sm shadow-sm focus:outline-none focus:ring-2 focus:ring-pink-500"
        />
        <input
          type="password"
          v-model="newPassword"
          placeholder="Nouveau mot de passe"
          class="border border-gray-200 rounded-lg px-3 py-2 text-sm shadow-sm focus:outline-none focus:ring-2 focus:ring-pink-500"
        />
        <input
          type="password"
          v-model="confirmPassword"
          placeholder="Confirmer le mot de passe"
          class="border border-gray-200 rounded-lg px-3 py-2 text-sm shadow-sm focus:outline-none focus:ring-2 focus:ring-pink-500"
        />
      </div>
    </div>
    <hr />



    <!-- Historique des connexions -->
    <div class="flex items-start justify-between">
      <label class="w-1/3 text-gray-600 font-medium text-sm mt-1">Historique des connexions</label>
      <div class="w-2/3 max-h-48 overflow-y-auto border border-gray-200 rounded-lg shadow-sm p-3 text-sm">
        <div v-for="(entry, index) in loginHistory" :key="index" class="mb-2">
          <p class="text-gray-700"><strong>{{ entry.date }}</strong> - {{ entry.device }} ({{ entry.ip }})</p>
        </div>
      </div>
    </div>




    <!-- Bouton de sauvegarde -->
    <div class="flex justify-end pt-4">
      <button
        @click="saveSecuritySettings"
        class="bg-blue-500 text-white px-6 py-2 rounded text-sm hover:bg-blue-600 transition"
      >
        Sauvegarder
      </button>
    </div>
  </div>
</template>

<script>
import { toast } from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';

export default {
  data() {
    return {
      currentPassword: '',
      newPassword: '',
      confirmPassword: '',
      twoFAEnabled: false,
      loginHistory: [],
      activeSessions: [], // si tu gères les sessions actives côté backend
    };
  },
  methods: {
    async saveSecuritySettings() {
      const token = localStorage.getItem("token");
      if (!token) return toast.error("Vous devez être connecté");

      try {
        // 1️⃣ Changement de mot de passe si rempli
        if (this.currentPassword && this.newPassword && this.confirmPassword) {
          const res = await fetch("https://datafuseweb-95a5588f8542.herokuapp.com/api/clients/password", {
            method: "PUT",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
              currentPassword: this.currentPassword,
              newPassword: this.newPassword,
              confirmPassword: this.confirmPassword,
            }),
          });
          const data = await res.json();
          if (!res.ok) throw new Error(data.message);
          toast.success("Mot de passe mis à jour !");
        }


        // 3️⃣ Rafraîchir l'historique
        this.fetchLoginHistory();

        // Reset champs mot de passe
        this.currentPassword = '';
        this.newPassword = '';
        this.confirmPassword = '';
      } catch (error) {
        console.error(error);
        toast.error("Erreur : " + error.message);
      }
    },

    async fetchLoginHistory() {
      const token = localStorage.getItem("token");
      if (!token) return;

      try {
        const res = await fetch("https://datafuseweb-95a5588f8542.herokuapp.com/api/clients/history", {
          headers: { Authorization: `Bearer ${token}` },
        });
        const data = await res.json();
        if (res.ok) this.loginHistory = data.map(e => ({
          date: new Date(e.date).toLocaleString(),
          device: e.browser || e.device || "Unknown",
          ip: e.ip,
        }));
      } catch (err) {
        console.error(err);
        toast.error("Impossible de charger l'historique");
      }
    },

    logoutSession(sessionId) {
      // Ici, tu peux ajouter un appel API pour supprimer la session côté backend si nécessaire
      this.activeSessions = this.activeSessions.filter(s => s.id !== sessionId);
      toast.success("Session déconnectée");
    },
  },

  async mounted() {
    // Récupérer l'état 2FA et l'historique dès le montage
    const token = localStorage.getItem("token");
    if (!token) return;

    try {
      // Historique des connexions
      await this.fetchLoginHistory();

      // On peut également récupérer le status 2FA si tu crées une route GET /api/admin/2fa
      // Exemple fictif :
      const res = await fetch("https://datafuseweb-95a5588f8542.herokuapp.com/api/admin/profile", {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await res.json();
      if (res.ok) this.twoFAEnabled = data.twoFactorEnabled || false;
    } catch (err) {
      console.error(err);
    }
  },
};
</script>


<style scoped>
hr {
  border-color: #e5e7eb; /* gris clair */
}
</style>
